const mutations = {
  setParticipantList(state, payload) {
    state.participantList = payload;
  },
  setPlanList(state, payload) {
    state.planList = payload;
  },
  setBenefitTypes(state, payload) {
    state.benefitTypes = payload;
  },
  setOrganizationList(state, payload) {
    state.organizationList = payload;
  },
  setEntityList(state, payload) {
    state.entityList = payload;
  },
  setInsurerList(state, payload) {
    state.insurerList = payload;
  },
  setPolicyList(state, payload) {
    state.policyList = payload;
  },

  setParticipant(state, payload) {
    state.participant = payload;
  },
  setPlan(state, payload) {
    state.plan = payload;
  },
  setOrganization(state, payload) {
    state.organization = payload;
  },
  setEntity(state, payload) {
    state.entity = payload;
  },
  setInsurer(state, payload) {
    state.insurer = payload;
  },
  setPolicy(state, payload) {
    state.policy = payload;
  },
  setBulkPolicyTemplate(state, payload) {
    state.bulkPolicyTemplate = payload;
  },
  setLogParticipant(state, payload) {
    state.log = payload;
  },
};

export default mutations;
